import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, Spinner } from '@scoring/frontend-shared';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Wraps a route that requires authentication. Redirects unauthenticated users
 * to /login. Shows a loading spinner while the auth state is being resolved.
 *
 * Requirements: 11.2 — draft events restricted to admins only (admin app
 * requires authentication for all routes).
 */
export function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { status } = useAuth();

  if (status === 'loading') {
    return <Spinner />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
